import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// Import translations
import ptBRCommon from '../locales/pt-BR/common.json'
import ptBRHomepage from '../locales/pt-BR/homepage.json'
import ptBRWorkforce from '../locales/pt-BR/workforce.json'
import ptBRContact from '../locales/pt-BR/contact.json'
import ptBRFooter from '../locales/pt-BR/footer.json'
import ptBRTechShowcase from '../locales/pt-BR/techShowcase.json'
import ptBRTechnology from '../locales/pt-BR/technology.json'
import ptBRPartners from '../locales/pt-BR/partners.json'
import ptBRRoadmap from '../locales/pt-BR/roadmap.json'
import ptBRSolutions from '../locales/pt-BR/solutions.json'
import ptBRGalleryTranslations from '../locales/pt-BR/gallery_translations.json'
import ptBRBeautyTranslations from '../locales/pt-BR/beauty_translations.json'
import ptBRErpTranslations from '../locales/pt-BR/erp_translations.json'
import ptBRBares from '../locales/pt-BR/bares.json'
import ptBRAnalytics from '../locales/pt-BR/analytics.json'
import ptBRDemo from '../locales/pt-BR/demo.json'
import ptBRDocs from '../locales/pt-BR/docs.json'
import ptBRSocial from '../locales/pt-BR/social.json'

import enCommon from '../locales/en/common.json'
import enHomepage from '../locales/en/homepage.json'
import enWorkforce from '../locales/en/workforce.json'
import enContact from '../locales/en/contact.json'
import enFooter from '../locales/en/footer.json'
import enTechShowcase from '../locales/en/techShowcase.json'
import enTechnology from '../locales/en/technology.json'
import enPartners from '../locales/en/partners.json'
import enRoadmap from '../locales/en/roadmap.json'
import enSolutions from '../locales/en/solutions.json'
import enGalleryTranslations from '../locales/en/gallery_translations.json'
import enBeautyTranslations from '../locales/en/beauty_translations.json'
import enErpTranslations from '../locales/en/erp_translations.json'
import enBares from '../locales/en/bares.json'
import enAnalytics from '../locales/en/analytics.json'
import enDemo from '../locales/en/demo.json'
import enDocs from '../locales/en/docs.json'
import enSocial from '../locales/en/social.json'

import esCommon from '../locales/es/common.json'
import esHomepage from '../locales/es/homepage.json'
import esWorkforce from '../locales/es/workforce.json'
import esContact from '../locales/es/contact.json'
import esFooter from '../locales/es/footer.json'
import esTechShowcase from '../locales/es/techShowcase.json'
import esTechnology from '../locales/es/technology.json'
import esPartners from '../locales/es/partners.json'
import esRoadmap from '../locales/es/roadmap.json'
import esSolutions from '../locales/es/solutions.json'
import esGalleryTranslations from '../locales/es/gallery_translations.json'
import esBeautyTranslations from '../locales/es/beauty_translations.json'
import esErpTranslations from '../locales/es/erp_translations.json'
import esBares from '../locales/es/bares.json'
import esAnalytics from '../locales/es/analytics.json'
import esDemo from '../locales/es/demo.json'
import esDocs from '../locales/es/docs.json'
import esSocial from '../locales/es/social.json'

import frCommon from '../locales/fr/common.json'
import frHomepage from '../locales/fr/homepage.json'
import frWorkforce from '../locales/fr/workforce.json'
import frContact from '../locales/fr/contact.json'
import frFooter from '../locales/fr/footer.json'
import frTechShowcase from '../locales/fr/techShowcase.json'
import frTechnology from '../locales/fr/technology.json'
import frPartners from '../locales/fr/partners.json'
import frRoadmap from '../locales/fr/roadmap.json'
import frSolutions from '../locales/fr/solutions.json'
import frGalleryTranslations from '../locales/fr/gallery_translations.json'
import frBeautyTranslations from '../locales/fr/beauty_translations.json'
import frErpTranslations from '../locales/fr/erp_translations.json'
import frBares from '../locales/fr/bares.json'
import frAnalytics from '../locales/fr/analytics.json'
import frDemo from '../locales/fr/demo.json'
import frDocs from '../locales/fr/docs.json'
import frSocial from '../locales/fr/social.json'

const resources = {
  'pt-BR': {
    common: ptBRCommon,
    homepage: ptBRHomepage,
    workforce: ptBRWorkforce,
    contact: ptBRContact,
    footer: ptBRFooter,
    techShowcase: ptBRTechShowcase,
    technology: ptBRTechnology,
    partners: ptBRPartners,
    roadmap: ptBRRoadmap,
    solutions: ptBRSolutions,
    gallery_translations: ptBRGalleryTranslations,
    beauty_translations: ptBRBeautyTranslations,
    erp_translations: ptBRErpTranslations,
    bares: ptBRBares,
    analytics: ptBRAnalytics,
    demo: ptBRDemo,
    docs: ptBRDocs,
    social: ptBRSocial
  },
  'en': {
    common: enCommon,
    homepage: enHomepage,
    workforce: enWorkforce,
    contact: enContact,
    footer: enFooter,
    techShowcase: enTechShowcase,
    technology: enTechnology,
    partners: enPartners,
    roadmap: enRoadmap,
    solutions: enSolutions,
    gallery_translations: enGalleryTranslations,
    beauty_translations: enBeautyTranslations,
    erp_translations: enErpTranslations,
    bares: enBares,
    analytics: enAnalytics,
    demo: enDemo,
    docs: enDocs,
    social: enSocial
  },
  'es': {
    common: esCommon,
    homepage: esHomepage,
    workforce: esWorkforce,
    contact: esContact,
    footer: esFooter,
    techShowcase: esTechShowcase,
    technology: esTechnology,
    partners: esPartners,
    roadmap: esRoadmap,
    solutions: esSolutions,
    gallery_translations: esGalleryTranslations,
    beauty_translations: esBeautyTranslations,
    erp_translations: esErpTranslations,
    bares: esBares,
    analytics: esAnalytics,
    demo: esDemo,
    docs: esDocs,
    social: esSocial
  },
  'fr': {
    common: frCommon,
    homepage: frHomepage,
    workforce: frWorkforce,
    contact: frContact,
    footer: frFooter,
    techShowcase: frTechShowcase,
    technology: frTechnology,
    partners: frPartners,
    roadmap: frRoadmap,
    solutions: frSolutions,
    gallery_translations: frGalleryTranslations,
    beauty_translations: frBeautyTranslations,
    erp_translations: frErpTranslations,
    bares: frBares,
    analytics: frAnalytics,
    demo: frDemo,
    docs: frDocs,
    social: frSocial
  }
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'pt-BR',
    defaultNS: 'common',
    ns: ['common', 'homepage', 'workforce', 'contact', 'partners', 'solutions', 'docs', 'social', 'bares'],
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'smartdata-language',
      caches: ['localStorage']
    },

    interpolation: {
      escapeValue: false // React already does escaping
    },

    react: {
      useSuspense: false
    }
  })

export default i18n
